import styled from 'styled-components';

export const TitleContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-bottom: 15px;

	& > p {
		text-shadow: 1px 1px #3b3b3b;
	}
`;

export const Iframe = styled.iframe`
	position: fixed;
	height: calc(100% - 80px - 49px);
	width: calc(100% - 80px);
	border: 0 none;
`;
